import { Outlet, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import QueryWrapper from "common/components/QueryWrapper";
import { PlayLayout } from "common/layouts/PlayLayout";

import {
  DEFAULT_PSG_BACKGROUND_MOBILE,
  DEFAULT_WHITE_COLOR,
} from "../../_graphic_design";
import { useGetHTMLPageQuery } from "htmlpage/api/html-page.api";

export function HtmlPageThemeWrapper() {
  const { htmlPageId } = useParams();
  const getHtmlPageQuery = useGetHTMLPageQuery(htmlPageId || skipToken);

  return (
    <QueryWrapper query={getHtmlPageQuery}>
      {(htmlPage) => {
        const gameTheme = {
          colors: {
            background: htmlPage?.backGroundColor || "#131527",
            text: DEFAULT_WHITE_COLOR,
          },
          images: {
            playBackground:
              htmlPage?.backGroundImage || DEFAULT_PSG_BACKGROUND_MOBILE,
          },
        };
        return (
          <PlayLayout theme={gameTheme}>
            <Outlet />
          </PlayLayout>
        );
      }}
    </QueryWrapper>
  );
}
